import { createFileRoute } from "@tanstack/react-router";

import ComingSoon from "~/components/miscellaneous/coming-soon";

export const Route = createFileRoute("/_main/reports/_layout/labour")({
  component: () => <ComingSoon />,
});
